import { ChipWithTooltip } from "ui";
import useQueueStore from "../../../../stores/queue-store";

const OpenQuestionnaire = () => {
  const setQuestionnaireWorkflowId = useQueueStore(
    (state) => state.setQuestionnaireWorkflowId
  );
  return (
    <ChipWithTooltip
      className="h-32 flex-1"
      // icon={<EllipsisRegularIcon />}
      title="Questionnaire"
      tooltipText="More"
      onClick={() => {
        setQuestionnaireWorkflowId(802);
      }}
    />
  );
};

export default OpenQuestionnaire;
